import React from 'react';

import {Button, Icon, Menu} from '@albert-io/atomic';

export type OverviewSortKey = 'name' | 'questions' | 'accuracy';

// Mirrors the legacy SortByBar options (Student name / Total questions / Raw accuracy).
const OPTIONS: {key: OverviewSortKey; label: string}[] = [
  {key: 'name', label: 'Student name'},
  {key: 'questions', label: 'Total questions'},
  {key: 'accuracy', label: 'Raw accuracy'}
];

interface Props {
  sortBy: OverviewSortKey;
  onChange: (key: OverviewSortKey) => void;
}

// "Sort by …" control for the accuracy roster; sorts within each mastery band client-side.
export const OverviewSortMenu = ({sortBy, onChange}: Props) => {
  const current = OPTIONS.find((option) => option.key === sortBy) ?? OPTIONS[0];
  return (
    <Menu closeOnItemClick position='bottom-end' positionFixed>
      <Menu.Trigger>
        {(triggerProps) => (
          <Button
            {...triggerProps}
            variant='text'
            size='s'
            className='pl-x0-half font-semibold! content-link! underline'
            aria-label={`Sort by ${current.label}`}
            data-testid='overview-sort'
          >
            {current.label}
            <Icon className='ml-x1' icon='caret-down' iconStyle='solid' />
          </Button>
        )}
      </Menu.Trigger>
      <Menu.Content>
        {OPTIONS.map((option) => (
          <Menu.Item
            key={option.key}
            selected={option.key === sortBy}
            rightIconProps={option.key === sortBy ? {icon: 'check'} : undefined}
            onClick={() => onChange(option.key)}
          >
            {option.label}
          </Menu.Item>
        ))}
      </Menu.Content>
    </Menu>
  );
};
